// extracted by mini-css-extract-plugin
module.exports = {"topBlankLine":"TermsAndConditions_topBlankLine__pn0xJ","link":"TermsAndConditions_link__HcrlG"};